// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2q38I","consentsList":"PatientConsents_consentsList__2klyn","consentsListEmpty":"PatientConsents_consentsListEmpty__2z9Wl"};